import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { NegocioPrioridade, prioridades } from '../negocio-prioridade';

@Component({
    selector: 'sgt-negocio-prioridade-select',
    templateUrl: './negocio-prioridade-select.component.html',
    styleUrls: ['./negocio-prioridade-select.component.less']
})
export class NegocioPrioridadeSelectComponent implements OnInit {
    prioridades = prioridades;

    /** Prioridade do negócio */
    @Input() idPrioridade: number;
    /** Ao alterar a prioridade do negócio */
    @Output() idPrioridadeChange = new EventEmitter<number>();
    /** Prioridade selecionada */
    prioridade: NegocioPrioridade;
    /** Prioridade alterada */
    @Output() prioridadeChange = new EventEmitter<NegocioPrioridade>();

    /** Se deve desabilitar o input */
    @Input() disabled: boolean;

    ngOnInit(): void {
        this.prioridade = this.prioridades.find(prioridadeFilter => prioridadeFilter.id == this.idPrioridade);
    }

    /** Ao selecionar a prioridade */
    select(prioridade: NegocioPrioridade) {
        this.idPrioridade = prioridade ? prioridade.id : null;
        this.idPrioridadeChange.emit(this.idPrioridade);
        this.prioridade = prioridade;
        this.prioridadeChange.emit(this.prioridade)
    }
}
